<template>
	<div id="loginpage" class="loginregist" :style="curWebsite.type == 2?'background:#fff':''">
		<div style="width:100%;" :class="{'por':true}">
			<!-- szy-login -->
			<div class="zl-index widthPC-90 margin-x-auto" v-if="curWebsite.type == 2">
				<h2 class="text-center mt-5 mb-3">中投顾问产业大脑，<span style="font-weight: normal;">产业研究、产业投资与产业招商数智化高效工具。</span></h2>
			<div class="flexcss">
			<div v-for="(zl_cydl,index) in zl_cydl_list" class="zl-index-con" :key="index" style="width: 530px"  @mouseenter="isShowZldnM = index+1" @mouseleave="isShowZldnM = 0">
				<p class="text-center name mb-1">{{ zl_cydl.name }}</p>
				<div class="zl-index-cydn" >
					<div class="left-font border" style="width: 530px;">
					<h3 class="title" id="weisite-title" style="font-size: 24px;">{{zl_cydl.title}}</h3>
					<ul id="font-list" style="font-size: 16px;">
						<li :key="index" v-for="(item,index) in zl_cydl.fontlist">{{item}}</li>
					</ul>
					<p class="yellowfont">……所有工作，只需点击几下鼠标就完成</p>
				</div>
				</div>
				<div class="clear-after isShowZldnM-box">
					<span class="cur-pointer fl inline-block mt1" @click="hanlderService('introduction'+(index+1))">功能介绍 > </span>
					<span class="cur-pointer fr inline-block mt1" @click="hanlderService('service'+(index+1))">服务方式 > </span>
				</div>
				</div>
			</div>
			<div class="bannerconbox my-2">
				<div class="con">
					<p class="ad-cd25">为了让用户能零门槛把握最新产业投资机会 ，<b>中投顾问产业大脑</b>特开展热点报告“<span class="red-font">限时免费阅读活动</span>”，现在即可申请<span class="red-font">免费</span>阅读以下报告：</p>
				<div class="rpt-box">
					<ul>
						<li><a href="https://www.ocn.com.cn/reports/18442renxingjiqiren.shtml" target="blank" title="2025-2029年中国未来产业之人形机器人行业趋势预测及投资机会研究报告" class="rpt-title">2025-2029年中国未来产业之人形机器人行业趋势预测及投资机会研究报告</a><a class="curp apply" @click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请 &gt; </a></li>
						<li><a href="https://www.ocn.com.cn/reports/18582rengongzhinengdamoxing.shtml" target="blank" title="2025-2029年中国未来产业之人工智能大模型行业应用场景剖析及投资机会研究报告" class="rpt-title">2025-2029年中国未来产业之人工智能大模型行业应用场景剖析及投资机会研究报告</a><a class="curp apply" @click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请 &gt; </a></li>
						<li><a href="https://www.ocn.com.cn/reports/18557dikongjingjijichusheshi.shtml" target="blank" title="2025-2029年中国低空经济基础设施投资模式评估及规划建议报告" class="rpt-title">2025-2029年中国低空经济基础设施投资模式评估及规划建议报告</a><a class="curp apply" @click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请 &gt; </a></li>
						<li><a href="https://www.ocn.com.cn/2012/1204yanglao.shtml" target="blank" title="2025-2029年中国养老产业投资分析及前景预测报告" class="rpt-title">2025-2029年中国养老产业投资分析及前景预测报告</a><a class="curp apply" @click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请 &gt; </a></li>
						<li><a href="https://www.ocn.com.cn/reports/18587xinxingdianchiyingyongchangjing.shtml" target="blank" title="2025-2029年中国新型电池行业应用场景剖析及投资机会研究报告" class="rpt-title">2025-2029年中国新型电池行业应用场景剖析及投资机会研究报告</a><a class="curp apply" @click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请 &gt; </a></li>
						<li><a href="https://www.ocn.com.cn/reports/18586changqizibennaixinziben.shtml" target="blank" title="22025年中国长期资本耐心资本发展白皮书" class="rpt-title">2025年中国长期资本耐心资本发展白皮书</a><a class="curp apply" @click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请 &gt; </a></li>
						<li><a href="https://www.ocn.com.cn/reports/18585xinnengyuanzhinengwanglianqiche.shtml" target="blank" title="2025-2029年中国未来产业之新能源及智能网联汽车产业趋势预测及投资机会研究报告" class="rpt-title">2025-2029年中国未来产业之新能源及智能网联汽车产业趋势预测及投资机会研究报告</a><a class="curp apply" @click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请 &gt; </a></li>
						<li><a href="https://www.ocn.com.cn/reports/18538duanju.shtml" target="blank" title="2025-2029年中国短剧行业深度调研及投资前景预测报告" class="rpt-title">2025-2029年中国短剧行业深度调研及投资前景预测报告</a><a class="curp apply" @click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请 &gt; </a></li>
						<li><a href="https://www.ocn.com.cn/reports/18595biaoganchengshikejichuangxin.shtml" target="blank" title="中国标杆城市科技创新与产业发展成功经验深度分析报告" class="rpt-title">中国标杆城市科技创新与产业发展成功经验深度分析报告(2025版)</a><a class="curp apply" @click="openSmWindow('https://q.url.cn/abLCUe?_type=wpa&amp;qidian=true')">现在申请 &gt; </a></li>
					</ul>
				</div>
				</div>
			</div>
		</div>
			<div class="login-center" v-if="curWebsite.type!= 7 && curWebsite.type!= 2">
				<div class="loginLogoBox oh" :style="curWebsite.type == 8?'padding-left:0;width:600px;text-align:center;margin:0':''" > 
					<!--  :style="curWebsite.type == 6?'padding-left:0;':''" -->
					<img src="@/assets/images/zt_logo_sm2.png" v-if="curWebsite.type != 8 && curWebsite.type != 9" alt="中投顾问" class="loginlogo fl" :style="curWebsite.type == 6?'margin-top:5px':''">
					<img src="@/assets/images/SIMA_logo.png" v-if="curWebsite.type == 9" alt="中投顾问" class="loginlogo fl" style="width: 74px;height: 74px">
					<h2 id="logoTitle" :class="curWebsite.type != 8 ? 'fl' : ''">
						<span id="logoTitle1" >{{curList.name}}</span> <br>
						<span class="opEnglish">Industrial Merchants Brain</span></h2>
				</div>
				<div class="clear"></div>
				<div class="left-font">
					<h3 class="title" id="weisite-title">{{curList.title}}</h3>
					<ul id="font-list">
						<li :key="index" v-for="(item,index) in curList.fontlist">{{item}}</li>
					</ul>
					<p class="yellowfont">……所有工作，只需点击几下鼠标就完成</p>
				</div>
				<div class="rightlogin">
					<div class="loginblock">
						<h4 class="login-form-title">账户登录</h4>
						<div class="login-form">
							<div class="login-line">
								<input type="text" v-model="logindata.username" @keydown="inputInDown" class="underlinput underlinput1 username" :placeholder="isPwdLogin?'请输入用户名':'请输入手机号'" name="username">
							</div>
							<!-- v-show="!logindata.isPhoneNumber || !isSmsLogin" -->
							<div class="login-line" v-show="isPwdLogin">
								<input type="password" v-model="logindata.password" @keydown="inputInDown" class="underlinput underlinput1 password" placeholder="请输入密码" name="password">
							</div>
							<!-- v-show="logindata.isPhoneNumber && isSmsLogin" -->
							<div class="login-line verification" v-show="!isPwdLogin">
								<input type="text" v-model="logindata.code" @keydown="inputInDown" class="underlinput underlinput1 password" placeholder="请输入验证码" name="password">
								<el-button class="verification-code-btn" size="medium" :disabled="codeSecond>0" @click="sendCode">获取验证码<span v-show="codeSecond>0">({{codeSecond}})</span></el-button>
							</div>
							<!-- <div>&nbsp;<br>&nbsp;</div> -->
							<button type="submit" class="loginsubmit submitbtn" @click="passwordLogin()">登录</button>
							<span class="curp fr login_type" @click="isPwdLogin = !isPwdLogin; errortext = '';logindata.username=''">{{ !isPwdLogin ? '账号密码' : '短信验证码' }}登录 >> </span>
							<!-- <button type="submit" class="loginsubmit submitbtn" v-show="curList.type==6" >登录</button> -->
						</div>
						<p class="errortext">{{errortext}}</p>
					</div>
				</div>
			</div>
		</div>
		
		<div class="login-introduction" id="login-introduction"  ref="introduction1" :style="curWebsite.type == 2?'margin:0 auto;background:#f4f6fa':''" v-if="curWebsite.type == 6 || curWebsite.type == 2">
			<div :class="isScroll ? 'titlebox tac scroll-titlebox' : 'titlebox tac'">
				<strong>产业研究大脑</strong><span>核心功能介绍</span>
				<a href="https://chanyeyanjiu.cn/#/totalEnterprises" target="_blank" class="link-teak" v-show="curWebsite.type == 2">访问体验版 > </a><i class="godownpng"></i>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">产业研究工作场景</th>
					<th>功能说明</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">做产业研究</h5>
					</td>
					<td class="midBorder">
						<span class="db">深度产业研究</span><span class="db">产业链研究</span><span class="db">投资趋势研究</span>
					</td>
					<td>
						<p>覆盖所有重点、热点行业，<strong>1000多份深度行业研究报告</strong>，可随时在线阅读，全面深入理解各个行业</p>
						<p>有<strong>240多条产业链图谱</strong>，能高效查找产业链各环节重点企业，并随时查看企业详细信息，产业链全景一览无余</p>
						<p>通过独家<strong>上市公司投资数据库、企业拿地投资数据库</strong>，把握各个产业投资趋势，分析龙头企业投资动向</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">做企业研究</h5>
					</td>
					<td class="midBorder">
						<span class="db">上市公司研究</span><span class="db">龙头企业研究</span><span class="db">创新企业研究</span><span
							class="db">外资企业研究</span>
					</td>
					<td>
						<p>通过<strong>5200多家A股上市企业库</strong>，高效查找各行业、各地区上市公司数据，并查看企业战略方向和投资布局；</p>
						<p>有包括<strong>500强、央企、国企在内的5万多家（非A股上市）龙头企业</strong>，查看每家企业投资动态和投资布局</p>
						<p><strong>7万多家获得融资的创新企业库</strong>，可以分地区、分行业进行高级查询，快速查找优质投资标的</p>
						<p>高效查找13万家外资企业、以及1600多家外资企业总部，查看该企业在国内的投资布局和投资动态</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">监测产业动态</h5>
					</td>
					<td class="midBorder">
						<span class="db">创新企业融资动态</span><span class="db">专业机构投资动态</span><span
							class="db">上市公司投资动态</span><span class="db">企业拿地投资动态</span>
					</td>
					<td>
						<p>查看最近12个月，<strong>每个月最新获得融资的科技型创新企业</strong>，可分阶段、分城市查询</p>
						<p>查找全国所有<strong>一级市场专业投资机构</strong>，并查看每家机构的<strong>投资方向和最新投资项目</strong>；可分城市、分行业查询</p>
						<p>实时监测所有上市公司公告的<strong>最新投资项目</strong>，对本行业标杆企业的的<strong>投资动态</strong>一目了然</p>
						<p>动态监测所有企业的<strong>拿地投资动态</strong>，对行业重点企业的<strong>投资布局、产能扩张动态</strong>全面掌握</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">产业排行榜</h5>
					</td>
					<td class="midBorder">
						<span class="db">重点产业城市排行</span><span class="db">热点产业企业排行</span><span
							class="db">重点城市产业排行</span><span class="db">重点区域企业排行</span>
					</td>
					<td>
						<p>通过产业、企业大数据，在选定重点产业后，对全国重点城市进行排行，各城市产业竞争格局，一目了然</p>
						<p>通过产业、企业大数据，选定任何区域、任何城市、任何产业，都可以立即自动对企业进行智能排序</p>
						<p>通过产业、企业大数据，对国内前20个重点城市，自动分析每个城市重点产业，及该产业的重点企业数量</p>
						<p>对长三角、珠|三角、京津冀、成渝及闽东南5个重点区域及相关城市进行分析，智能筛选出重点龙头企业</p>
					</td>
				</tr> 
			</table>
			<ul class="login-induction-font">
				<li><strong>产品价值：</strong><span>让研究机构、政府和企业的研究部门高效进行产业研究、企业研究，随时掌握相关行业动态</span></li>
				<li><strong>服务方案：</strong><span>产业研究大脑 + 产品使用培训（即大数据高效研究方法培训，确保全员掌握） + 后续服务</span></li>
			</ul>
		</div>
		<div class="login-introduction service-introduction"  ref="service1" :style="curWebsite.type == 2?'margin:0 auto;background:#f4f6fa':''" id="login-service" v-if="curWebsite.type == 6 || curWebsite.type == 2">
			<div class="titlebox tac ">
				<strong>产业研究大脑</strong><span>服务方式介绍</span>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">服务方式</th>
					<th>收费方式</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">1.在线服务</h5>
					</td>
					<td class="midBorder">云端在线SaaS服务，最为便捷，开通账号即可立即使用；免维护、成本低、功能全、迭代快</td>
					<td class="font-size18">按账号收年度服务费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">2.数据服务</h5>
					</td>
					<td class="midBorder">通过API 接口为用户提供数据服务，可以与用户已有客户管理系统无缝对接，开发周期1-2个月</td>
					<td class="font-size18">每年数据使用费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">3.定制服务</h5>
					</td>
					<td class="midBorder">定制开发某城市产业研究大脑或某产业研究大脑，网站域名及界面都可定制，开发周期1-3个月</td>
					<td class="font-size18">开发费 + 年度维护费</td>
				</tr>
			</table>
			<p class="login-induction-font-sm">
				说明：以上服务，只与政府、企业、大学、研究机构等最终用户签约合作；第三方信息化公司可作为技术服务机构，协助用户现有研究管理系统与我们的数据系统进行技术对接。</p>
		</div>
		<div class="login-introduction" id="login-introduction" ref="introduction2" v-if="curWebsite.type == 5 || curWebsite.type == 2">
			<div :class="isScroll ? 'titlebox tac scroll-titlebox' : 'titlebox tac'">
				<strong>产业投资大脑</strong><span>核心功能介绍</span>
				<a href="https://www.chanyetouzi.com/#/totalEnterprises"  target="_blank" class="link-teak" v-show="curWebsite.type == 2">访问体验版 > </a><i class="godownpng"></i>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">企业战略投资工作场景</th>
					<th>功能说明</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">看投资动态</h5>
					</td>
					<td class="midBorder">
						<span class="db">创新企业融资动态</span><span class="db">专业机构投资动态</span><span
							class="db">上市公司投资动态</span><span class="db">企业拿地投资动态</span>
					</td>
					<td>
						<p>查看最近12个月，<strong>每个月最新获得融资的科技型创新企业，</strong>可分阶段、分城市查询；</p>
						<p>查找全国所有<strong>专业投资机构，</strong>查看每家机构的<strong>投资方向和最新投资项目，</strong>可分城市、分行业查询；</p>
						<p>实时监测所有上市公司公告的 ，<strong>最新投资项目</strong>对行业标杆企业的<strong>投资动态</strong>一目了然；</p>
						<p>动态监测所有企业的<strong>拿地投资动态</strong>对行业重点企业的<strong>投资布局、产能扩张动态</strong>全面掌握；</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">做产业研究</h5>
					</td>
					<td class="midBorder">
						<span class="db">查看行业研究报告</span><span class="db">查看产业链图谱</span><span class="db">查看产业投资大数据</span><span class="db">查看对标企业</span>
					</td>
					<td>
						<p>覆盖所有重点、热点行业，<strong>1000多份深度行业研究报告</strong>，随时在线阅读，快速全面了解一个新行业；</p>
						<p>有<strong>260多条产业链图谱</strong>，高效查找产业链各环节重点企业，并随时查看企业详细信息；</p>
						<p>独家<strong>上市公司投资数据库、企业拿地投资数据库</strong>可以进行各种组合高级查询，透视产业投资最新动态</p>
						<p>通过看<strong>上市公司库、龙头企业库、外资企业库</strong>，掌握对标企业的投资动态及投资布局；</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">找投资标的</h5>
					</td>
					<td class="midBorder">
						<span class="db">创新企业库-找标的</span><span class="db">优质企业库-找标的</span>
					</td>
					<td>
						<p>查找<strong>天使轮、种子轮、ABCD各轮次获得融资</strong>的科技型企业，可以分城市、分行业高效查询；</p>
						<p>查找带<strong>专精特新企业、雏鹰企业、高新技术企业</strong>等科技标签的企业，可分城市、分行业查找；</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">查智能推荐</h5>
					</td>
					<td class="midBorder">
						<span class="db">智能推荐投资标的</span><span class="db">智能推荐投资机构</span>
					</td>
					<td>
						<p>根据企业用户关注的<strong>新兴产业方向</strong>设置标签，系统自动<strong>新兴产业方向</strong>智能推荐最新投资标的；</p>
						<p>根据用户关注的<strong>产业方向标签，</strong>系统<strong>自动推荐相关产业的专业投资机构，</strong>掌握机构最新投资动态；</p>
					</td>
				</tr>
			</table>
		</div>
		<div class="login-introduction service-introduction" ref="service2" id="login-service" v-if="curWebsite.type == 5 || curWebsite.type == 2">
			<div class="titlebox tac ">
				<strong>产业投资大脑</strong><span>服务方式介绍</span>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">服务方式</th>
					<th>收费方式</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">1.在线服务</h5>
					</td>
					<td class="midBorder">云端在线SaaS服务，最为便捷，开通账号即可立即使用；免维护、成本低、功能全、迭代快</td>
					<td class="font-size18">按账号收年度服务费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">2.数据服务</h5>
					</td>
					<td class="midBorder">通过API 接口为用户提供数据服务，可以与用户已有客户管理系统无缝对接，开发周期1-2个月</td>
					<td class="font-size18">每年数据使用费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">3.定制服务</h5>
					</td>
					<td class="midBorder">定制开发某产业投资大脑或某企业投资大脑，网站域名及界面都可定制，开发周期1-3个月</td>
					<td class="font-size18">开发费 + 年度维护费</td>
				</tr>
			</table>
			<p class="login-induction-font-sm">
				说明：以上服务，只与企业集团、企业、投资机构等最终用户签约合作；第三方信息化公司可以作为技术服务机构，协助用户现有客户管理系统与我们的数据系统进行技术对接。</p>
		</div>
		<div class="login-introduction" id="login-introduction" ref="introduction3" :style="curWebsite.type == 2?'margin:0 auto;background:#f4f6fa':''"
			v-if="(curWebsite.type == 1 || curWebsite.type == 8|| curWebsite.type == 9 || curWebsite.type == 2) && !demonstrate">
			<div :class="isScroll ? 'titlebox tac scroll-titlebox' : 'titlebox tac'">
				<strong>{{curWebsite.type == 7 ? '上海产业运算大数据平台':'产业招商大脑'}}</strong><span>核心功能介绍</span>
				<a href="https://www.zhaoshangdanao.com/#/totalEnterprises" target="_blank" class="link-teak" v-show="curWebsite.type == 2">访问体验版 > </a>
				<i class="godownpng" v-show="curWebsite.type == 1"></i>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">招商工作场景</th>
					<th>功能说明</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">看机会</h5>
					</td>
					<td class="midBorder"><span class="db">产业投资-招商机会</span><span class="db">产业转移-招商机会</span><span
							class="db">企业投资-招商机会</span></td>
					<td>
						<p>监测<strong>重点产业的上市公司投资动态、企业拿地动态</strong>，发现产业招商机会</p>
						<p>监测<strong>发达省份、城市的产业转移动态</strong>，发现区域产业转移招商机会</p>
						<p>监测<strong>龙头企业拿地投资动态</strong>，挖掘重点行业龙头招商机会</p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">找企业</h5>
					</td>
					<td class="midBorder"><span class="db">产业链招商-找企业</span><span class="db">驻点招商-找企业</span><span
							class="db">资本招商-找企业</span></td>
					<td>
						<p>从<strong>全国产业图谱</strong>找龙头企业；自动诊断<strong>本地产业链</strong>，找强链补链目标招商企业</p>
						<p>在北上广深等重点城市招商，<strong>快速锁定重点产业和龙头企业</strong></p>
						<p>快速查找<strong>专业投资机构</strong>及其投资方向；及时查找<strong>最新获投创新企业</strong></p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">做研判</h5>
					</td>
					<td class="midBorder"><span class="db">研判企业投资意向</span><span class="db"></span><span
							class="db">评估企业投资实力</span></td>
					<td>
						<p>看业务和产品，看实际投资项目，看投资概率，<strong>判断投资意向</strong></p>
						<p>分析投资布局、分析上下游企业、分析科技创新实力，<strong>评估投资实力</strong></p>
					</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">建联系</h5>
					</td>
					<td class="midBorder"><span class="db">企业-企业 关系计算器</span><span class="db">企业-城市 关系计算器</span><span
							class="db"></span></td>
					<td>
						<p>通过认识的企业，计算与目标企业的关系链，再让中间企业介绍，联系目标企业</p>
						<p>通过本城市的企业，计算与目标企业的关系链，让本地企业牵线搭桥、以商招商</p>
					</td>
				</tr>
			</table>
			<ul class="login-induction-font">
				<li><strong>服务效果：</strong><span>让全市（区、县、园区）参与招商的所有队伍，从传统招商方式，升级为大数据精准招商方式</span></li>
				<li><strong>服务方案：</strong><span>产业招商大脑 + 产品使用培训（即大数据精准招商方法培训，确保全员掌握） + 后续专业服务</span></li>
			</ul>
		</div>
		<div class="login-introduction service-introduction" ref="service3" id="login-service" :style="curWebsite.type == 2?'margin:0 auto;background:#f4f6fa':''" v-if="curWebsite.type == 1 || curWebsite.type == 9 || curWebsite.type == 2">
			<div class="titlebox tac">
				<strong>产业招商大脑</strong><span>服务方式介绍</span>
			</div>
			<table border="0" cellspacing="0" cellpadding="0" class="login-table">
				<tr>
					<th colspan="2">服务方式</th>
					<th>收费方式</th>
				</tr>
				<tr>
					<td>
						<h5 class="title">1.在线服务</h5>
					</td>
					<td class="midBorder">云端在线SaaS服务，最为快捷，开通账号即可立即使用；开通快、成本低、功能强、免维护 </td>
					<td class="font-size18">按账号收年度服务费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">2.数据服务</h5>
					</td>
					<td class="midBorder">通过API 接口为用户提供数据服务，可以与用户已有招商管理系统无缝对接，开发周期1-2个月</td>
					<td class="font-size18">每年数据使用费</td>
				</tr>
				<tr>
					<td>
						<h5 class="title">3.定制服务</h5>
					</td>
					<td class="midBorder">定制开发某城市招商大脑或某产业招商大脑，网站域名及界面都可定制，开发周期1-3个月</td>
					<td class="font-size18">开发费 + 年度维护费</td>
				</tr>
			</table>
			<p class="login-induction-font-sm">
				说明：以上服务，只与政府、园区、平台公司等最终用户签约合作；第三方信息化公司可作为技术服务机构，协助用户现有招商管理系统与我们的数据系统进行技术对接。</p>
		</div>
		
		
		<!-- <rightNav :type="curWebsite.type == 7 ? 3 : 2" v-if="curWebsite.type != 8"></rightNav> -->
		<!-- <input type="hidden" name="_token" value="bwe4UyMX306KIOJCXhCsrHRYSECjBt9dC8teP63c"> -->
	<!-- 用户使用时间到期提示弹框 -->
	<div class="tipspopbox_bg" v-show="expiredBtn" v-if="!other_channel">
		<div class="tipspopbox">
			<span class="closebtn" @click="expiredBtn=false"></span>
			<div class="">
				<h5 class="title tac orangefont fz24 lh48">账号过期提醒</h5>  
				<p class="mt-2 tac fz18 lh42">您的账号：<span class="darkred">{{logindata.username}}</span>，已于<span class="darkred">{{endDate}}</span>过期。<br>
				如需账号延期，请 <a class="curp"  href="https://wpa1.qq.com/4sai7BwX?_type=wpa&qidian=true" target="_blank">在线咨询 ></a> ，或微信咨询：</p>
			 <div class="right-slide-wechat mga por">
			 	<span class="wechatfont">扫一扫  加微信咨询我们</span>
			 	<div class="wechat_codebox fl">
			 		<img src="../../assets/images/zixuncode-lss.png">
			 		<p class="tac">中投顾问 - 刘姗姗</p>
			 	</div>
			 	<div class="wechat_codebox fr">
			 		<img src="../../assets/images/zixuncode-bl.png">
			 		<p class="tac">中投顾问 - 白灵</p>
			 	</div>  
			 </div>
			</div>
		</div> 
		<!-- <div class="enprise_lockbox"> 
			<p class="redtips onetip" v-html="tipstext"></p>   
			<span class="closebtn" @click="expiredBtn=false"></span>
		</div> -->
	</div>
	</div>
</template>

<script>
import { data } from "jquery";
import { mapState, mapMutations, mapGetters } from "vuex";
	export default {
		name: 'userlogin',
		computed: {
		...mapState({
		isMsgAlert: (state) => state.isMsgAlert,
		isSmsLogin: (state) => state.isSmsLogin,
		isDomainAllowedFlag : (state) => state.isDomainAllowedFlag,
		isChannelUser: (state) => state.isChannelUser,
		}),
		...mapGetters(['isMsgAlert','isSmsLogin','isDomainAllowedFlag','isChannelUser'])
		},
		props: {},
		data() {
			return {
				isPwdLogin: false,
				timerclock:null, //验证码计时器
				codeSecond:0,//验证码倒计时
				isSendCode:false,
				expiredBtn:false,
				endDate:'',
				other_channel:false,
				testhref: "zhaoshangdanao.com.cn",
				curWebsite: this.$api.getWebsiteType(),
				demonstrate: this.$api.demonstrate(),
				autoOpenOperate: false,
				loginurl: this.$api.user.user.login(),
				isScroll: false,
				collectUrl: '',
				logindata: {
					username: "",
					password: '',
					code: '',
					client: 1,
					token:null,
					refer:null,
					isPhoneNumber: false,
				},
				curList: {
					name: "",
					url: "",
					title: "",
					fontlist: []
				},
				errortext: '',
				isTzdn: false,
				nolocal: true,
				nowdate: new Date().getMonth() + 1 + '-' + new Date().getDate(),
				crmuserdata: {},
				list1: {
					xzbg: {
						code: "Z-XZBG",
						name: "下载报告",
						btn: false
					},
					jrxmgl: {
						code: "Z-JRXMGL",
						name: "加入项目管理",
						btn: false
					},
					jrmbqy: {
						code: "Z-JRMBQY",
						name: "加入目标企业",
						btn: false
					},
					jrqytzdt: {
						code: "Z-JRQYTZDT",
						name: "加入企业投资动态",
						btn: false
					},
					jyfznlpgbg: {
						code: "Z-JYFZNLPGBG",
						name: "经营发展能力评估报告",
						btn: false
					},
					cwfxbg: {
						code: "Z-CWFXBG",
						name: "财务分析报告",
						btn: false
					},
					mkczsm: {
						code: "Z-MKCZSM",
						name: "模块操作说明",
						btn: false
					},
				},
				zl_cydl_list: [{
						type: 6,
						name: '产业研究大脑',
						url: 'chanyeyanjiu.cn',
						title: "产业研究的数字化高效工具",
						fontlist: [
							'1000多份深度研究报告随意查看，实现“读报告自由” ',
							'240多条动态产业链图谱阅读，产业链上下游一览无余',
							'标杆企业、行业龙头企业投资布局、投资动态实时跟踪',
							'创新企业融资动态、风投机构投资动态，实时动态跟踪',
						]
					},
					{
						type: 5,
						name: '产业投资大脑',
						url: 'touzidanao.com',
						title: "企业战略投资部的数智化助手",
						fontlist: [
							'新兴产业、热门赛道所有投资标的智能推荐',
							'所有专业投资机构投资动态，全面动态监测',
							'标杆企业、行业龙头投资动态实时跟踪',
							'动态产业图谱，沿产业链梳理各环节企业'
						]
					},
					{
						type: 1,
						name: '产业招商大脑',
						url: 'zhaoshangdanao.com',
						title: "大数据精准招商专业平台",
						fontlist: [
							'产业链招商，找行业龙头企业',
							'到北上深驻点招商，找当地龙头企业',
							'判断一家企业的投资意向',
							'通过关系计算器，获得企业的联系方式'
						]
					},
				],
				typelist: [{
						type: 1,
						name: '产业招商大脑',
						url: 'zhaoshangdanao.com',
						title: "大数据精准招商专业平台",
						fontlist: [
							'产业链招商，找行业龙头企业',
							'到北上深驻点招商，找当地龙头企业',
							'判断一家企业的投资意向',
							'通过关系计算器，获得企业的联系方式'
						]
					},
					{
						type: 9,
						name: '产业招商大脑',
						url: 'sima.chanyedanao.cn',
						title: "大数据精准招商专业平台",
						fontlist: [
							'产业链招商，找行业龙头企业',
							'到北上深驻点招商，找当地龙头企业',
							'判断一家企业的投资意向',
							'通过关系计算器，获得企业的联系方式'
						]
					},
					{
							type: 8,
							name: '产业招商大脑',
							url: 'zs.chanyedanao.cn',
							title: "大数据精准招商专业平台",
							fontlist: [
								'产业链招商，找行业龙头企业',
								'到北上深驻点招商，找当地龙头企业',
								'判断一家企业的投资意向',
								'通过关系计算器，获得企业的联系方式'
							]
						},
					{
						type: 2,
						name: '产业大脑-产业治理大脑',
						url: 'chanyedanao.cn',
						title: "政府产业治理部门的高效工具",
						fontlist: [
							'通过本地产业图谱，自动诊断本地产业链的完整度',
							'240条全国产业图谱，随便查找产业各环节重点企业',
							'全国所有重点企业投资动态，实时跟踪监测',
							'处于投资窗口期、发展机会大的产业，智能推荐'
						]
					},
					{
						type: 3,
						name: '园区招商大脑',
						url: 'yuanqudanao.com',
						title: "",
						fontlist: []
					},
					{
						type: 4,
						name: '产业大脑-产业信贷大脑',
						url: 'xindaidanao.com',
						title: "企业信贷需求挖掘高效工具",
						fontlist: [
							'沿着产业链图谱，快速锁定行业重点企业',
							'产业链金融，围绕龙头企业上下游找融资企业',
							'投贷联动，挖掘有资质、有融资需求的科技型企业',
							'企业投资（融资）窗口期，挖掘信贷需求大的企业',
						]
					},
					{
						type: 5,
						name: '产业投资大脑',
						url: 'touzidanao.com',
						title: "企业战略投资部的数智化助手",
						fontlist: [
							'新兴产业、热门赛道所有投资标的智能推荐',
							'所有专业投资机构投资动态，全面动态监测',
							'标杆企业、行业龙头投资动态实时跟踪',
							'动态产业图谱，沿产业链梳理各环节企业'
						]
					},
					{
						type: 6,
						name: '产业研究大脑',
						url: 'chanyeyanjiu.cn',
						title: "产业研究的数字化高效工具",
						fontlist: [
							'1000多份深度研究报告随意查看，实现“读报告自由” ',
							'240多条动态产业链图谱阅读，产业链上下游一览无余',
							'标杆企业、行业龙头企业投资布局、投资动态实时跟踪',
							'创新企业融资动态、风投机构投资动态，实时动态跟踪',
						]
					},
					{
						type: 10,
						name: '产业研究大脑',
						url: 'cs.chanyedanao.cn',
						title: "产业研究的数字化高效工具",
						fontlist: [
							'1000多份深度研究报告随意查看，实现“读报告自由” ',
							'240多条动态产业链图谱阅读，产业链上下游一览无余',
							'标杆企业、行业龙头企业投资布局、投资动态实时跟踪',
							'创新企业融资动态、风投机构投资动态，实时动态跟踪',
						]
					},
					{
						type: 7,
						name: '上海产业集群大数据平台',
						url: 'zhaoshangdanao.com.cn',
						title: "",
						fontlist: []
					},
				],
				isShowZldnM:0,
			}
		},
		created() {
			
			
			var ddd = this.typelist.filter(list => {
				return list.type == this.curWebsite.type;
			});
			this.curList = ddd[0];
			document.title = this.curList.name;
			if(this.curList.name == '产业研究大脑'){
				document.title = this.curList.name;
			}
			if(this.curWebsite.type == 2){
				document.title = "中投顾问产业大脑，产业研究咨询数智化高效工具";

			}
			this.logindata.refer = this.$route.query.refer;
			this.logindata.token = this.$route.query.token;
			// console.log(this.loginurl)
		},
		mounted() {
			this.bus.$emit('loading', false);
			// console.log('来源-----', document.referrer);
			var that = this;
			document.getElementById('loginpage').addEventListener('scroll', function() {
				that.isScroll = this.scrollTop > 168;
			})
			this.other_channel=this.curWebsite.type == 7 || this.curWebsite == 8;
			//2024-20.23 体验版跳转过来需要定位到服务介绍，增加了锚点定位
			const hash = window.location.hash;

			// 定义需要检查的锚点列表
			const anchorList = ['login-service', 'login-introduction'];

			// 查找匹配的锚点
			const matchedAnchor = anchorList.find(anchor => hash.includes(`#${anchor}`));

			if (matchedAnchor) {
				const element = document.getElementById(matchedAnchor);
				if (element) {
					element.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动到目标元素
				}
			} else {
				// 如果没有匹配的锚点，检查是否需要执行域名验证逻辑
				if (this.isDomainAllowedFlag) {
					this.isDomainAllowed();
				}
			}
			if(this.logindata.token && this.logindata.refer){ //陕投默认登录入口
				this.logindata.token = this.decodeURI(this.logindata.token);
				this.logindata.refer = this.decodeURI(this.logindata.refer);
				console.log(this.logindata);
				this.passwordLogin();
			}
		},
		
		methods: {
			...mapMutations({
				set_msgAlert: "SET_MSGAlERT",
				set_isSmsLogin: "SET_ISSMSLOGIN",
				set_isDomainAllowedFlag: "SET_ISDOMAINALLOWEDFLAG",
				set_isChannelUser: "SET_ISCHANNELUSER",
        	}),
			 //在线咨询打开小窗口
 		openSmWindow(url) {
	        try {
	            window.open(url, "_blank","height=600,width=800,top=200,left=200,status=yes,toolbar=no,menubar=no,resizable=yes,scrollbars=no,location=no,titlebar=no");
	             _hmt.push(['_trackEvent', '报告', '咨询', '在线客服'])
	        } catch (e) { }
	        return false;
	    },
		// 点击服务方式 、产品介绍跳转
			hanlderService(sectionId){
				console.log(sectionId);
				
				const section = this.$refs[sectionId];
				if (section) {
					section.scrollIntoView({ behavior: 'smooth' }); // 平滑滚动
				}
			},
			//陕投项目会从他们那边跳转过来到我们企业详情，要默认给他登陆方便查看
			// base64解密
			 decodeURI(text){
				console.log(text);
					text = text.replace(/%3D/ig, '=').replace(/-/g, '+').replace(/_/g, '/');
					return window.atob(text);
				},
				// 判断域名
				isDomainAllowed() { //从我们自己宣传也进来的绕过登录页，市场部开的账号到登录页
					const hostname = document.referrer;
					console.log(hostname);
					const allowedDomains = 'ocn.com.cn';
					let isAllowed = hostname.indexOf(allowedDomains) > -1;
					if (isAllowed) {
						this.set_isDomainAllowedFlag(false);
						this.$router.push('/totalEnterprises');
					}
				},
    
			// 校验手机号是否正确
			checkInput(){
				return new Promise((resolve,reject)=>{
					console.log(this.logindata.username);
					this.logindata.isPhoneNumber = false ;
					this.set_isSmsLogin(false);
					// this.isSmsLogin = false;
					let phone_number_reg = /^((\+|00)86)?1[3-9]\d{9}$/;
					if(this.logindata.username !=''){
						if(phone_number_reg.test(this.logindata.username)){
							this.logindata.isPhoneNumber = true ;
							this.checkSmsLogin().then(res=>{
								resolve(res);
							})
						}else{
							this.errortext = '请输入正确的手机号';
							resolve(false);
						}
					}else{
						this.errortext = '手机号不能为空';
						resolve(false);

					}
				})
				
			},
			//调用后台接口检测手机号是否设置为短信登陆
			checkSmsLogin(){
				return new Promise((resolve,reject)=>{
					let _this = this;
				let ajaxUrl = this.$api.common.sms.isSmsLogin()+"?mobile="+this.logindata.username;
				this.$axios.get(ajaxUrl).then(function(res) {
					console.log('检测是否设置短信登陆',res);
					if(res.data.success){
						_this.set_isSmsLogin(true);
						_this.errortext = '';
						resolve(true);
						// _this.isSmsLogin = true;
					}else{
						_this.set_isSmsLogin(false);
						_this.errortext = '您尚未开通短信登录服务，请联系客服';
						// _this.isSmsLogin = false;
						resolve(false);
					}
					}).catch(function (error) {
					// 处理错误情况
					console.log(error);
					})
				})
				
			},
			//发送验证码
			sendCode() {
				this.checkInput().then(res=>{
					if(!res){
						return;
					}else{
						let _this = this;
				let ajaxUrl = this.$api.common.sms.send()+"?mobile="+this.logindata.username+'&type=2';
				this.$axios.get(ajaxUrl).then(function(res) {
					// console.log('发送验证码',res); 
					if(res.data.success){
						_this.$message.success(res.data.msg); 
						if(res.data.code == 0){
						_this.codeSecond=60;
						_this.timerclock=setInterval(function(){ //设置1分钟倒计时定时器
							_this.codeSecond--;
							if(_this.codeSecond == 0){
								clearInterval(_this.timerclock) //清空定时器
							}
							// console.log(_this.codeSecond)
							},1000)
						}
					}else{
						let errMsg = res.data.msg;
						if(res.data.code == 1022){
							errMsg = '短信日下发条数超过设定的上限';
						}else if(res.data.code == 1023){
							errMsg = '手机号30秒内下发短信条数超过设定的上限';
						}else if(res.data.code == 1024){
							errMsg = '手机号1小时内下发短信条数超过设定的上限';
						}else if(res.data.code == 1025){
							errMsg = '手机号日下发短信条数超过设定的上限';
						}
						_this.$message.error(errMsg); 
					}
					
					}).catch(function (error) {
					// 处理错误情况
					console.log(error);
					})
					}
				})
				
				
			},
			addToBookMark() { 
				var url = window.location.href;
				var title = this.curWebsite.name;
				var ua = navigator.userAgent.toLowerCase();
				if (ua.indexOf("msie 8") > -1) {
					external.AddToFavoritesBar(url, title, "河北超高压"); //IE8
				} else {
					try {
						window.external.addFavorite(url, title);
					} catch (e) {
						try {
							window.sidebar.addPanel(title, url, "河北超高压"); //firefox
						} catch (e) {
							alert("加入收藏失败，请使用Ctrl+D进行添加");
						}
					}
				}
				return false;
			},
			inputInDown(e) {
				if (e.keyCode == 13) {
					this.passwordLogin()
				};
			},
			passwordLogin() {  
				
				// 如果是短信登陆则清空密码，密码登陆清空验证码，防止有自动填充情况出现
				if(this.logindata.token && this.logindata.refer){
					this.logindata.password = '';
					this.logindata.username ='';
				}else if(this.isSmsLogin || !this.isPwdLogin){
					this.logindata.password = '';
					if (this.logindata.username == '' || this.logindata.code == '') {
						this.errortext = '未填写用户名/验证码';
						return;
					};
				}else{
					this.logindata.code='';
					if (this.logindata.username == '' || this.logindata.password == '') {
						this.errortext = '未填写用户名/密码';
						return;
					};
				}
				// console.log('登陆',this.logindata);
				
				var that = this;
				var loginurl = this.$api.user.user.login();
				this.bus.$emit('loading', true);
				// +'?username='+this.logindata.username+'&password='+this.logindata.password+'&client=1' 
				$.ajax({
					type: "post",
					url: loginurl,
					data: this.logindata,
					success: function(res) {
						var resdata = res; 
						console.log('登陆返回',resdata);
						// resdata.success=false;
						// resdata.msg='用户过期123';
						// resdata.data='2024-2-21';
						// resdata.code = 100102;
						if (resdata.success) {
							var logindata = resdata.data; 
							if (logindata.domain.indexOf('yj.chanyedanao') > -1) {
								logindata.domain = logindata.domain +
									',tg.chanyedanao.cn,//chanyedanao,www.chanyedanao.cn';
							}
							that.loginsuccess(logindata);
							localStorage.setItem('token', logindata.token);
							sessionStorage.setItem('token', logindata.token);
							
						} else {
							that.bus.$emit('loading', false);
							that.errortext = resdata.msg;
							if(resdata.code == 100102 && !that.other_channel){
								that.expiredBtn=true;
								that.endDate=resdata.data;
							}
						} 
					}
				})
			},
			loginsuccess(datasm) {
				console.log('loginsucces 设置消息提示');
				//20240422设置登陆成功1分钟后促销消息提示
				 setTimeout(()=>{
					this.set_msgAlert(true);
				},60000);
				datasm.currentCity = this.getSetCity(datasm); //将用户所在地区提取出来 
				datasm.autoOpenOperate = false;
				datasm.datetime = this.nowdate;
				var oplist = datasm.menu.filter(list => {
					return list.code == 'Z';
				});
				// console.log('没有修改的原始数据',datasm,oplist);

				datasm.operatList = this.operatList(oplist[0].children);
				this.$axios.get(this.$api.cyl.home.notice(), {
					headers: {
						AuthToken: datasm.token
					}
				}).then(function(res) {}).catch(function(error) {});
				this.crmlogin(datasm);
			},
			//用户工作台权限
			crmlogin(datasm) {
				var that = this;
				console.log('crmlogin5')
				that.routerLoginUrl(datasm);
				// that.bus.$emit('loading', false);
				$.ajax({
					type: "get",
					url: this.$api.crm.user.login(),
					headers: {
						AuthToken: datasm.token
					},
					success: function(res) { 
						if (res.success) {
							that.crmuserdata = res.data;
							datasm.crmInfor = res.data; 
							that.routerLoginUrl(datasm);
							that.bus.$emit('loading', false);
						}
					}
				})
/***/


				// this.bus.$emit('loading', true);  
				// this.$axios.get(this.$api.crm.user.login(),{headers:{AuthToken:datasm.token}}).then(function(res){ 
				// 	console.log('2',res,datasm)
				// 	if(res.data.success){    
				// 		that.crmuserdata = res.data.data;
				// 		datasm.crmInfor=res.data.data; 
				// 		that.routerLoginUrl(datasm);  
				// 		localStorage.setItem('userData', datasm);
				// 		sessionStorage.setItem('userData', datasm);  
				// 		that.bus.$emit('loading', false); 
				// 	}
				// 	else{ 

				// 	} 
				// }).catch(function (error) {
				// 	// 请求失败处理 console.log(error);
				// });  
			},
			//版本判断是否能进入
			routerLoginUrl(datasm) {
				var datasm1 = ''; 
				// datasm.groupType=0;  
				// datasm.loginNum=1;//试用账号测试专用
				datasm.autoOperate=false;
				let type1=datasm.groupType == 1?1:0;
				datasm.zsdn_version= (this.curWebsite.type == 1 || this.curWebsite.type == 7) ? type1 + 1 : 2;//简易版和专业版的初始设置 招商大脑试用账户默认进入简易版
				
				
				datasm.zsdn_version_num=1;//简易版和专业版切换次数 
				datasm.isChannel = true;//当前页面登录的用户为渠道用户
				//拦截token设置特殊token
				// datasm.token ='4aef66eae5b3026530eb2625048bf8bc';
				// datasm.province = 36;
				if (typeof datasm === 'object') {
					datasm1 = JSON.stringify(datasm);
				}
				// console.log('routerLoginUrl',datasm1)
				var isMatch = false;
				var showcom = datasm.domain.split(',');
				var hrefl = window.location.href.toLowerCase();
				for (var i = 0; i < showcom.length; i++) {
					if (hrefl.indexOf(showcom[i]) > -1) {
						isMatch = true;
					}
				}
				this.nolocal = hrefl.indexOf(".cn") > 0 || hrefl.indexOf(".com") > 0;
				// console.log('logindata',logindata);
				// console.log(hrefl,'登录时网址') 
				if (this.nolocal && !isMatch) {
					// that.errortext="账号与版本不对应，请进入正确版本";
					this.$message({
						message: '账号与版本不对应，请进入正确版本,3s后跳转',
						type: 'error'
					})
					setTimeout(function() {
						window.location.href = "http://" + showcom[0];
					}, 4000)
				} else {
					
					localStorage.setItem('userData', datasm1);
					sessionStorage.setItem('userData', datasm1);
					var curWebsite = this.$api.getWebsiteType();
					var indexPath="";
					if(datasm.isPopup){ //后台设置了是否要默认进入首页
						indexPath="/homePage";
					}else if(this.logindata.token && this.logindata.refer){ //陕投跳转
						indexPath = this.logindata.refer

					}else if (curWebsite.type == 3 || curWebsite.type == 4) {
						//园区/信贷大脑跳转全部楼宇页面
						indexPath="/allBuildings"; 
					} else if(curWebsite.type == 5) {
						//投资大脑跳创新企业融资页面
						indexPath="/investment-clues3"; 
					}else if(curWebsite.type == 6){
						//研究大脑跳转省市区域竞争 
						// indexPath="/regional-competitiveness?type=2"; 
						// 研究大脑跳转产业机会在哪里
						indexPath="/report?type=w0"; 
					}else if(curWebsite.type == 1 || curWebsite.type == 7){
						//招商大脑和上海数据平台有简易版
						if(datasm.groupType == 1){
							indexPath="/totalEnterprises";
						}else{
							indexPath="/invest-project-trend?type=3";//试用账户自动设置成简易版 企业本市投资项目
						} 
					}else{
						//其余跳上市企业
						indexPath="/enterpriseList?type=9&Pt=1"; 
					}
					console.log('跳转',indexPath)
					this.$router.push({
						path: indexPath,
					});
				}
			},
			//下载/项目管理等权限存储
			operatList(data) {
				for (var i = 0; i < data.length; i++) {
					let code1 = data[i].code;
					// console.log(code1);
					if (code1 == "Z-XZBG") { //11.30修改所有版本内资企业都有下载报告按钮
						this.list1.xzbg.btn = true;
					} else if (code1 == "Z-JRXMGL") {
						this.list1.jrxmgl.btn = true;
					} else if (code1 == "Z-JRMBQY") {
						this.list1.jrmbqy.btn = true;
					} else if (code1 == "Z-JRQYTZDT") {
						this.list1.jrqytzdt.btn = true;
					} else if (code1 == "Z-JYFZNLPGBG") {
						this.list1.jyfznlpgbg.btn = true;
					} else if (code1 == "Z-CWFXBG") {
						this.list1.cwfxbg.btn = true;
					} else if (code1 == "Z-MKCZSM" && this.curWebsite.type == 1) {
						this.list1.mkczsm.btn = true; //只有招商大脑才要展示模块和服务手册
					}
				};
				return this.list1;
			},

		},

	}
</script>

<style scoped>
.swiper-item{
	position: relative;
	height: 100%;
	width: 100%;
}
.swiper-item1{
	background:url('../../assets/zs_login_banner1.jpg');
	background-size:100% 100%;

}
.swiper-item2{
	background:url('../../assets/zs_login_banner2.jpg');
	background-size:100% 100%;

}
.swiper-item3{
	background:url('../../assets/zs_login_banner3.jpg');
	background-size:100% 100%;

}
.swiper-item4{
	background:url('../../assets/zs_login_banner4.jpg');
	background-size:100% 100%;

}

.syzs-login{
	height:97vh;
	width:100vw;
	/* border:1px solid red; */
}
.syzs-login1{
	min-height:105vh;
	width:100vw;
	background:url('../../assets/zs_login_banner.jpg');
	background-size:100% 100%;
	color: #fff;
}
.el-carousel--horizontal{
	width:100vw;
	/* border:1px solid green; */
}
.website-company{
	text-align: center;
	display:block;
	/* color: #333; */
	font-size: 20px;
}
.el-carousel__item h3 {
    color: #475669;
    font-size: 18px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }
  
  .el-carousel__item:nth-child(2n) {
    background-color: #99a9bf;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #d3dce6;
  }
  .login_type{
  	margin-top: 36px;
	font-size: 14px;
  }
</style>